import * as R from 'ramda';
import {createReducer} from "./index";
import {API_GET_ADDRESS_BOOK_USERS_DONE, CLEAR_ADDRESS_BOOK} from "../actions/addressbook";

const addressBookReducer = createReducer([],
  {
    [API_GET_ADDRESS_BOOK_USERS_DONE]: (state, action) => R.concat(state, action.payload),
    [CLEAR_ADDRESS_BOOK]: (state, action) => [],
    // 'ACTION_NAME': function (state, action) -> new_state
  });

export default addressBookReducer;


// WEBPACK FOOTER //
// ./src/reducers/addressBook.js